module.exports = __webpack_public_path__ + "img/1.32fda145.jpg";